<template>
  <div class="container">

    <div v-if="file.name" class="tile tile-centered">
      <div class="tile-icon">
        <span v-if="file.accepted" class="label label-success">Approved</span>
        <span v-else class="label label-warning">Pending approval</span>
      </div>
      <div class="tile-content">
        <p class="tile-title">{{file.name}}</p>
        <label v-if="error" class="label label-error">{{error}}</label>
      </div>
      <div class="tile-action">
        <button @click="del" class="btn" :class="{loading: saving}">
          <i aria-hidden="true" class="fa fa-trash-o"></i>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'fileItem',
  props: ['file', 'matter'],
  data () {
    return {
      error: '',
      saving: false
    }
  },
  methods: {
    del () {
      this.saving = true
      this.error = ''
      let form = new FormData()
      form.append('matter_id', this.matter._id)
      form.append('file_id', this.file.id)

      axios.post('/api/drive/delete', form)
      .then(res => {
        if (res.status === 200) {
          this.saving = false
          this.$emit('deleted')
        }
      })
      .catch(e => {
        this.saving = false
        this.error = e.response.data
      })
    }
  }
}
</script>

<style scoped>
.tile {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// fileItem.vue?016badb6